import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	// non-final until text is finalised

	versionUpdateErrorTitle: {
		id: 'backlog.common.hooks.version-update-error-title-non-final',
		defaultMessage: 'Failed to update',
		description: 'Title for the error flag when updating versions for issues fails',
	},
	versionUpdateErrorDescription: {
		id: 'backlog.common.hooks.version-update-error-description-non-final',
		defaultMessage: 'Refresh the page and try again.',
		description: 'Description for the error flag when updating versions for issues fails',
	},
});
